<template>
  <div class="space-y-1">
    <div class="font-bold text-white">Error</div>
    <p class="text-white">{{ message }}</p>
    <CVButton v-if="error" variant="danger" :disabled="sentFeedback" @click="reportError">
      {{ sentFeedback ? 'Feedback sent' : 'Report Error' }}
    </CVButton>
  </div>
</template>
<script setup lang="ts">
import * as Sentry from '@sentry/vue';
import { ref } from 'vue';
import CVButton from '@/components/buttons/CVButton.vue';

const sentFeedback = ref(false);

const props = defineProps<{
  message: string;
  error?: Error;
}>();

const reportError = () => {
  const event = Sentry.captureException(props.error!, {
    extra: {
      forceReport: true,
    },
  });
  Sentry.captureFeedback({
    message: 'Something went wrong',
    associatedEventId: event,
  });
  sentFeedback.value = true;
};
</script>
